import {useSelector} from 'react-redux';

import BadgesGrid from '@/components/BadgesGrid/BadgesGrid';
import {BADGE_TRACKING} from '@/consts/badgeTracking';
import useBadgeDetailRoute from '@/hooks/useBadgeDetailRoute';
import {trackBadgeClicked} from '@/services/events/loyaltyEventTracking';
import {selectAllBadges} from '@/state/selectors/loyalty';
import type {Badge} from '@/types/loyalty';

const BadgesCollectionSection = () => {
    const badges = useSelector(selectAllBadges);
    const {openBadge} = useBadgeDetailRoute();

    if (!badges.length) return null;

    const handleBadgeClick = (badge: Badge) => {
        trackBadgeClicked(badge.title, BADGE_TRACKING.PAGE_IDS.BADGES);
        openBadge(badge);
    };

    return <BadgesGrid className='px-4' badges={badges} onBadgeClick={handleBadgeClick} />;
};

export default BadgesCollectionSection;
